export class CerFormZoom {
  private activeInstances: any[] = [];

  public async add(container: HTMLElement, options: any = null) : Promise<any> {
    //https://github.com/anvaka/panzoom
    const panzoom = await import("panzoom");
    const panzoomInstance = panzoom.default(container, options);
    this.activeInstances.push(panzoomInstance);
    return panzoomInstance;
  }

  public destroy() {
    this.activeInstances.forEach(panZoom => panZoom.dispose());
  }
}